export default "__VITE_ASSET__27ffb20d__"